
export enum materialFeatureText {
  HERO_TITLE = "Smarter Material Planning with Ease Margin ",
  HERO_DESCRIPTION = `Plan Confidently. Procure Smartly. Deliver On Time.`,
  HERO_BUTTON = "Get Started for Free",

  INTRO_TITLE = "Your Materials, Always in Sync with Your Production ",
  INTRO_DESCRIPTION = `With Ease Margin’s powerful Material Resource Planning (MRP), you'll never worry about missing materials or overstocking again. Our intelligent planning engine helps you align material availability with your unique production flow whether it's order-based, schedule-driven, or stock-prepared.`,

  DASHBOARD_TITLE = "📊 Key Benefits at a Glance",

  FLEX_PLAN_TITLE = "Flexible Planning, Just the Way You Need It.",
  FLEX_PLAN_DESC = "Every manufacturing process is unique. Ease Margin’s MRP adapts to yours. Whether you’re fulfilling custom orders or building for stock, our system adjusts to your strategy and helps you stay ahead.",
  CTA_TITLE = "🚀 Want to see how it works?",
  CTA_BUTTON = "Contact Us for a Free Demo",
}

export const materialDashboardFeatures = [
  "Smart material calculations based on real-time business needs",
  "Instant purchase request generation ",
  "Seamless integration with inventory and production",
  "Multi-level BOM support for complex manufacturing",
  "Faster planning, reduced waste, and on-time deliveries",
];
